import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// This utility function is used to transform the Kallisto theme tokens into CSS variables.
// It recursively traverses the tokens and converts them to CSS variables.

export function transformToCssVars(tokens, topLevelKey) {
  function transform(obj) {
    var parentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return Object.entries(obj).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      var currentPath = [].concat(_toConsumableArray(parentPath), [key]);
      var varPath = [topLevelKey].concat(_toConsumableArray(currentPath)).join('-');
      if (value && _typeof(value) === 'object') {
        acc[key] = transform(value, currentPath);
      } else {
        acc[key] = value.toString().startsWith('var(--') ? value : "var(--lmn-ds-".concat(varPath, ")");
      }
      return acc;
    }, {});
  }
  return transform(tokens);
}